import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { err, ok, Result } from "neverthrow"
import { DeviceToCloudBlobType, selectLatestDeviceToCloudBlob } from "../dal/ldbDeviceToCloudBlob"
import { CloudToDeviceBlobType, CloudToDeviceBlobUpnAll, selectCloudToDeviceBlob } from "../dal/ldbCloudToDeviceBlob"

// "must" because null is an error;
// we are expecting this value to be in the table
export const mustSelectEncounterFileDataUrl = async (encounterGuid: string, fileId: string, upn: string): Promise<Result<string, FusionError>> => {
	let data: BlobPart|null = null
	let contentType: string|null = null
	const rSelect1 = await selectLatestDeviceToCloudBlob({
		type: DeviceToCloudBlobType.EncounterFile,
		encounterGuid,
		fileId,
		upn,
	})
	if(rSelect1.isErr()) {
		return err(serializeFusionError('mustSelectEncounterFile', rSelect1.error))
	}
	if(rSelect1.value) {
		const dbBlob = rSelect1.value
		data = dbBlob.data as BlobPart	
		contentType = dbBlob.contentType
	} else {
		const rSelect2 = await selectCloudToDeviceBlob({
			type: CloudToDeviceBlobType.EncounterFile,
			id: fileId,
			upn: CloudToDeviceBlobUpnAll,
		})
		if(rSelect2.isErr()) {
			return err(serializeFusionError('mustSelectEncounterFile', rSelect2.error))
		}
		if(rSelect2.value) {
			const dbBlob = rSelect2.value
			data = dbBlob.data as BlobPart	
			contentType = dbBlob.contentType
		}
	}
	if(!data) {
		return err(serializeFusionError('mustSelectEncounterFile', 'file not found'))
	}
	if(!contentType) {
		return err(serializeFusionError('mustSelectEncounterFile', 'expected contentType but null'))
	}
	const jsBlob = new Blob([data], { type: contentType })
	return ok(URL.createObjectURL(jsBlob))
}
